import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import {
  GtagEvent,
  GtagConfig,
} from './google-tag-manager/google-tag-manager.interface';

declare const gtag: Function;
declare const hj: Function;

@Injectable({
  providedIn: 'root',
})
export class TrackingService {
  private _mergedConfig: GtagConfig;
  testBrowser: boolean;
  constructor(
    @Inject('config') gaConfig: GtagConfig,
    private _router: Router,
    @Inject(PLATFORM_ID) platformId: string
  ) {
    this.testBrowser = isPlatformBrowser(platformId);
    this._mergedConfig = {
      trackPageviews: false,
      trackHotjarGTM: false,
      enableHotjarEvent: false,
      ...gaConfig,
    };
    if (this._mergedConfig.trackPageviews && this.testBrowser) {
      this._router.events
        .pipe(
          filter(
            (event): event is NavigationEnd => event instanceof NavigationEnd
          )
        )
        .subscribe((event) => {
          if (event.urlAfterRedirects.includes('/launch-survey')) {
            this.gTagEvent('draft_survey', {
              event_category: 'Survey_Launch',
              event_label: 'Draft Survey Clicked',
            });
          }
          if (event.urlAfterRedirects.includes('/dashboard')) {
            const lastSegment = event.urlAfterRedirects.split('/').pop();
            const pattern = /^\d+$/;
            if (lastSegment && pattern.test(lastSegment)) {
              this.gTagEvent('manage_survey', {
                event_category: 'Survey_Details',
                event_label: 'Survey Details Opened',
              });
            }
          }
          this._pageView(event);
        });
    }
  }

  gTagEvent(eventName: string, eventParameters: GtagEvent = {}) {
    try {
      if (this._mergedConfig.trackPageviews) {
        gtag('event', eventName, eventParameters);
      }
      if (this._mergedConfig.trackHotjarGTM) {
        const { event_label } = eventParameters;
        this.hotjarEvent(event_label);
      }
    } catch (err) {
      console.error('Google Analytics event error', err);
    }
  }

  hotjarEvent(eventName: string = '') {
    try {
      if (this._mergedConfig.enableHotjarEvent) {
        hj('event', eventName);
      }
    } catch (err) {
      console.error('Hotjar event error', err);
    }
  }

  config(params: any = {}) {
    try {
      if (this._mergedConfig.trackPageviews) {
        gtag('config', this._mergedConfig.trackingId, params);
      }
    } catch (err) {
      console.error('Google Analytics config error', err);
    }
  }

  _pageView(event: NavigationEnd) {
    try {
      const page_title = event.urlAfterRedirects.split('/').pop();

      const params = {
        page_path: event.urlAfterRedirects,
        page_title,
      };
      if (this._mergedConfig.trackPageviews) {
        gtag('set', 'page_title', page_title);
        gtag('config', this._mergedConfig.trackingId, params);
      }
    } catch (err) {
      console.error('Google Analytics page view error', err);
    }
  }
}
